import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  title: {
    marginTop: 40,
    marginBottom: 24,
  },
  inputWrapper: {
    '&:nth-child(n+2)': {
      marginTop: '24px',
    },
  },
  textRight: {
    textAlign: 'right',
  },
  resetPassword: {
    textAlign: 'right',
    color: theme.palette.secondary.dark,
    marginTop: 16,
  },
  submitButton: {
    width: '100%',
    margin: '32px 0 24px',
  },
  greyText: {
    color: theme.palette.text.disabled,
    textAlign: 'center',
  },
  blueText: {
    color: theme.palette.primary.dark,
    fontWeight: 700,
  },
}));

export default useStyles;
